export const principalRoute = {
  login: 'login',
  serverUnavailable: 'server-unavailable',
  verbalList: 'lista-verbali',
  verbalDetail: 'dettaglio-verbale/:id',
  submitForm: 'invio-modulo/:id',
  faq: 'faq'
}

export const principalRouteNavigate = {
  login: '/login',
  serverUnavailable: '/server-unavailable',
  verbalList: '/lista-verbali',
  verbalDetail: '/lista-verbali/dettaglio-verbale/',
  submitForm: '/lista-verbali/invio-modulo/',
  faq: '/faq'
}
